<template>
  <div class="phone">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="手机号">
        <el-input v-model="form.mobile" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
      </el-form-item>
      <div class="flex">
        <el-button type="danger" @click="cancel">取消</el-button>
        <el-button type="primary" @click="onSubmit">确定</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  props: ['multipleSelection', 'form'],
  data() {
    return {}
  },
  methods: {
    onSubmit() {
      if (this.form.mobile == '') {
        _g.toast("warning", '手机号不能为空!');
        return
      }
      var data = this.multipleSelection;
      var id = [];
      data.map(function (item, index) {
        id.push(item.id);
      });
      this.form.sknMaterialId = id.toString()
      api.request('/skn/updateSknMaterialMobile', this.form, (res) => {
        // console.log(res)
        if (res.result == true) {
          _g.toast("success", '修改成功');
          this.$emit('close')
          this.$emit('add-comment')
        } else {
          _g.toast("error", res.errMsg);
        }
      }, (err) => { })
    },
    cancel() {
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
.flex {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
</style>